import subjectDemographicsComponent from './subjectDemographics.component';

const subjectDemographicsModule = angular.module('app.components.cde.subjectDemographics', [])
    .component('subjectDemographics', subjectDemographicsComponent)
    .name;

export default subjectDemographicsModule;
